import axios from '../../../../../api/axios';
import { toast } from 'react-toastify';

const BASE = '/v2/knowledge-base';

const handleError = (error, msg) => {
  const message = error.response?.data?.message || error.message || msg;
  toast.error(message);
  throw new Error(message);
};

export const getAllKnowledgeBases = async (params = {}) => {
  try {
    const res = await axios.get(BASE, { params });
    return res.data;
  } catch (e) { handleError(e, 'Failed to fetch knowledge base entries'); }
};

export const getKnowledgeBaseById = async (id) => {
  try {
    const res = await axios.get(`${BASE}/${id}`);
    return res.data;
  } catch (e) { handleError(e, 'Failed to fetch entry'); }
};

export const createKnowledgeBase = async (payload) => {
  try {
    const res = await axios.post(BASE, payload);
    return res.data;
  } catch (e) { handleError(e, 'Failed to create entry'); }
};

export const updateKnowledgeBase = async (id, payload) => {
  try {
    const res = await axios.patch(`${BASE}/${id}`, payload);
    return res.data;
  } catch (e) { handleError(e, 'Failed to update entry'); }
};

export const deleteKnowledgeBase = async (id) => {
  try {
    const res = await axios.delete(`${BASE}/${id}`);
    return res.data;
  } catch (e) { handleError(e, 'Failed to delete entry'); }
};

export const toggleKnowledgeBaseActive = async (id) => {
  try {
    const res = await axios.patch(`${BASE}/${id}/toggle-active`);
    return res.data;
  } catch (e) { handleError(e, 'Failed to toggle status'); }
};

export const addFloorPlan = async (id, payload) => {
  try {
    const res = await axios.post(`${BASE}/${id}/floor-plans`, payload);
    return res.data;
  } catch (e) { handleError(e, 'Failed to add floor plan'); }
};

export const updateFloorPlan = async (id, floorPlanId, payload) => {
  try {
    const res = await axios.patch(`${BASE}/${id}/floor-plans/${floorPlanId}`, payload);
    return res.data;
  } catch (e) { handleError(e, 'Failed to update floor plan'); }
};

export const deleteFloorPlan = async (id, floorPlanId) => {
  try {
    const res = await axios.delete(`${BASE}/${id}/floor-plans/${floorPlanId}`);
    return res.data;
  } catch (e) { handleError(e, 'Failed to delete floor plan'); }
};

export const addEvent = async (id, payload) => {
  try {
    const res = await axios.post(`${BASE}/${id}/events`, payload);
    return res.data;
  } catch (e) { handleError(e, 'Failed to add event'); }
};

export const deleteEvent = async (id, eventId) => {
  try {
    const res = await axios.delete(`${BASE}/${id}/events/${eventId}`);
    return res.data;
  } catch (e) { handleError(e, 'Failed to delete event'); }
};